<div class="modal-header">
  <h4 class="modal-title">Idle Check</h4>
</div>
<div class="modal-body text-center">Are you still there?</div>
<div class="modal-footer" *ngIf="viewModel$ | async as vm">
  <button
    type="button"
    class="btn btn-primary"
    *ngIf="(vm.tick || 0) < 10"
    (click)="stillHere()"
  >
    Still Here
  </button>
  <button
    type="button"
    class="btn btn-secondary"
    *ngIf="(vm.tick || 0) >= 10"
    (click)="returnToWork()"
  >
    Return to Work
  </button>
</div>
